// Standard library imports
import React, { useState } from 'react';

import TabsComponent from '../../components/Tabs/Tabs';
import classes from './Economics.module.css';
import Overview from '../Reusables/Economics/Overview';
import Ledger from '../Reusables/Economics/Ledger';
import { useQueryParamWithDefault } from '../../hooks';
import SmartCharge from '../Reusables/Economics/SmartCharge/SmartCharge';

// External library imports
import { NumberParam } from 'use-query-params';

const Economics = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);

    const tabs = [
        {
            name: 'Ledger',
            component: <Ledger cId={cId} setSelectedIndex={setSelectedIndex} />,
            tabId: 1,
        },
        {
            name: 'Overview',
            component: <Overview cId={cId} />,
            tabId: 2,
        },
        {
            name: 'Smart Charge Ledger',
            component: <SmartCharge cId={cId} />,
            tabId: 3,
        },
    ];
    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                tabs={tabs}
                selectedIndex={selectedIndex}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default Economics;
